<template>
	<v-overlay :value="overlay.active" color="white" opacity="0.75" class="d-flex">
		<Loading />
		<h2 class="black-color pa-2 py-7">{{ $t(overlay.text) }}</h2>
	</v-overlay>
</template>
<script lang="ts">
import Vue from "vue";
import Loading from "./Loading.vue";

export default Vue.extend({
	name: "LoadingOverlay",
	components: {
		Loading
	},
	computed: {
		overlay() {
			return this.$store.state.components.overlay;
		}
	}
});
</script>
<style scoped>
.v-overlay {
	position: absolute;
	top: 0;
	z-index: 499 !important;
}

.black-color {
	color: black;
}
</style>
